<template>
  <section class="stats" v-if="country">
    <div class="grid">
      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.circularity" alt="" class="stat-icon" />
        </div>
        <h3>Circular Material Use (CMU)</h3>
        <p class="value">{{ country.stats.circularity }}</p>
        <p>in {{ country.name }} (2024)</p>
      </div>

      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.highDigital" alt="" class="stat-icon" />
        </div>
        <h3>High Digital Intensity</h3>
        <p class="value">{{ country.stats.highDigital }}</p>
        <p>of SMEs in {{ country.name }}</p>
      </div>

      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.digitalIntensity" alt="" class="stat-icon" />
        </div>
        <h3>Basic Digital Intensity</h3>
        <p class="value">{{ country.stats.digitalIntensity }}</p>
        <p>adoption rate (2024)</p>
      </div>

      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.gdpVolume" alt="" class="stat-icon" />
        </div>
        <h3>GDP Volume Index</h3>
        <p class="value">{{ country.stats.gdpVolume }}</p>
        <p>(EU average = 100)</p>
      </div>

      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.productivity" alt="" class="stat-icon" />
        </div>
        <h3>Real Labour Productivity</h3>
        <p class="value">{{ country.stats.productivity }}</p>
        <p>(2015 = 100 base index)</p>
      </div>

      <div class="stat">
        <div class="icon-wrapper">
          <img :src="icons.womenEntrepreneurs" alt="" class="stat-icon" />
        </div>
        <h3>Female Self-employment</h3>
        <p class="value">{{ country.stats.womenEntrepreneurs }}</p>
        <p>of total female employment</p>
      </div>
    </div>
  </section>
</template>

<script>
import CircularIcon from '../../assets/img/we-circular/Stats/Circular.svg'
import CloudIcon from '../../assets/img/we-circular/Stats/Cloud.svg'
import MonitorIcon from '../../assets/img/we-circular/Stats/Monitor.svg'
import GraphIcon from '../../assets/img/we-circular/Stats/Graph.svg'
import BagIcon from '../../assets/img/we-circular/Stats/Bag.svg'
import PlusIcon from '../../assets/img/we-circular/Stats/Plus.svg'
export default {
  // Megkapja a teljes country objektumot a szülőtől
  props: ['country'],
  data() {
    return {
      icons: {
        circularity: CircularIcon,
        highDigital: CloudIcon,
        digitalIntensity: MonitorIcon,
        gdpVolume: GraphIcon,
        productivity: BagIcon,
        womenEntrepreneurs: PlusIcon
      }
    }
  }
}
</script>

<style scoped>
.stats {
  padding: 60px 0;
  background: #f8fafc; /* Világosabb, modernebb szürke */
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1100px;
  margin: auto;
  padding: 0 20px;
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  margin: 0 auto 18px;
  border-radius: 10px;
  background: #18baa8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon {
  width: 28px;
  height: 28px;
  display: block;
  object-fit: contain;
}

.stat {
  background: white; /* Fehér kártya háttér a rácson belül */
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease;
}

.stat:hover {
  transform: translateY(-5px);
}

h3 {
  font-size: 16px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 15px;
  min-height: 40px; /* Hogy a címek egy vonalban legyenek */
  display: flex;
  align-items: center;
  justify-content: center;
}

.value {
  font-size: 38px;
  font-weight: 800;
  color: #2563eb;
  margin-bottom: 5px;
}

p:not(.value) {
  font-size: 14px;
  color: #94a3b8;
}

/* Mobilos nézet */
@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
